<template>
  <div>
    <div id="viewer" dir="ltr" class="missionReport"></div>
  </div>
</template>
<script>
import ShearedMixin from '@/Mixins/Shared.js';
import ReportMixin from '@/Mixins/Report/ReportMixin.js';
export default {
  name: 'app',
  inject: ['load'],
  mixins: [ShearedMixin, ReportMixin],
  data() {
    return {
      reportType: '',
    };
  },
  created() { },
  mounted: function () {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      let routeInfo = this.$route.params.id;
      let data = routeInfo.split('-');
      this.reportType = data[2];
      if (data[2] == 1) {
        this.getLimitPcrFormAccidentTraumaFunction(data[0], data[1]);
      } else if (data[2] == 2) {
        this.getLimitPcrFormOtherTraumaFunction(data[0], data[1]);
      } else if (data[2] == 3) {
        this.getLimitPcrFormBrainStrokeFunction(data[0], data[1]);
      } else if (data[2] == 4) {
        this.getLimitPcrFormHeartFunction(data[0], data[1]);
      } else if (data[2] == 5) {
        this.getLimitPcrFormDiseaseFunction(data[0], data[1]);
      } else if (data[2] == 6) {
        this.getLimitPcrFormWithoutPatientFunction(data[0]);
      }
    },
    makeDataReadyForExport: function (info) {
      JSON.stringify(info, function (key, value) {
        if (typeof value === 'object' && value && !Array.isArray(value)) {
          return Object.keys(value).reduce(function (obj, k) {
            obj[k.charAt(0).toUpperCase() + k.slice(1)] = value[k];
            info = obj;
            return obj;
          }, {});
        }
        return value;
      });
      window.Stimulsoft.Base.StiLicense.Key =
        '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkcgIvwL0jnpsDqRpWg5FI5kt2G7A0tYIcUygBh1sPs7plofUOqPB1a4HBIXJB621mau2oiAIj+ysU7gKUXfjn/D5BocmduNB+ZMiDGPxFrAp3PoD0nYNkkWh8r7gBZ1v/JZSXGE3bQDrCQCNSy6mgby+iFAMV8/PuZ1z77U+Xz3fkpbm6MYQXYp3cQooLGLUti7k1TFWrnawT0iEEDJ2iRcU9wLqn2g9UiWesEZtKwI/UmEI2T7nv5NbgV+CHguu6QU4WWzFpIgW+3LUnKCT/vCDY+ymzgycw9A9+HFSzARiPzgOaAuQYrFDpzhXV+ZeX31AxWlnzjDWqpfluygSNPtGul5gyNt2CEoJD1Yom0VN9fvRonYsMsimkFFx2AwyVpPcs+JfVBtpPbTcZscnzUdmiIvxv8Gcin6sNSibM6in/uUKFt3bVgW/XeMYa7MLGF53kvBSwi78poUDigA2n12SmghLR0AHxyEDIgZGOTbNI33GWu7ZsPBeUdGu55R8w=';
      let options = new window.Stimulsoft.Viewer.StiViewerOptions();
      let viewer = new window.Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);
      let report = new window.Stimulsoft.Report.StiReport();
      let dataSet = new window.Stimulsoft.System.Data.DataSet('AsayarTrauma');
      dataSet.readJson(info);
      report.regData(dataSet.dataSetName, '', dataSet);
      if (this.reportType == 1) {
        report.loadFile('/Files/ReportTrauma.mrt');
      } else if (this.reportType == 2) {
        report.loadFile('/Files/ReportOtherTrauma.mrt');
      } else if (this.reportType == 3) {
        report.loadFile('/Files/ReportBrainStroke.mrt');
      } else if (this.reportType == 4) {
        report.loadFile('/Files/ReportHeart247.mrt');
      } else if (this.reportType == 5) {
        report.loadFile('/Files/ReportDisease.mrt');
      } else if (this.reportType == 6) {
        report.loadFile('/Files/ReportDisease.mrt');
      }
      viewer.report = report;
      viewer.renderHtml('viewer');
      if (this.load.val) {
        this.load.val = false;
      }
    },
  },
};
</script>

<style>
>>>.stiJsViewerPage>>>div {
  color: white !important;
}

.missionReport * {}

.missionReport .stiJsViewerClearAllStyles:nth-of-type(3) {
  display: none !important;
}
</style>
